<template>
    <div>
         <div style="font-size:18px;width:98%">
             <el-row :gutter="20">
                <el-col :span="4">
                    总工时：{{taskReportData.spentTime | hoursToDays}}
                </el-col>
                <el-col :span="20">
                
                </el-col>
            </el-row>
         </div>
        <div style="margin-top:30px;">
             <div id="monthlySpentTimeChart" :style="{width: '98%', height: '300px'}"></div>
        </div>
        <div style="margin-top:30px;width:98%">
             <!-- <el-row :gutter="0">
                 <el-col :span="12">
                      <div id="organizationSpentTimeChart" :style="{width: '98%', height: '300px'}"></div>
                </el-col>
                <el-col :span="12">
                
                </el-col>
            </el-row> -->
            <div id="organizationSpentTimeChart" :style="{width: '98%', height: '300px'}"></div>
         </div>
    </div>
</template>


<script>
export default {
  name: "taskReportDialog_Collect",
  props: ["taskReportDialogChildProps"],
  data() {
    return {
         workingHours:window.Glob.WorkingHours,
     // taskId:this.taskReportDialogChildProps.taskId,
      monthlySpentTimeData:null,
      getMonthlySpentTimeDataTableGroupByTaskArgs:null,
      organizationSpentTimeData:null,
      getOrganizationSpentTimeDataTableGroupByTaskArgs:null,
      taskReportData:{
          spentTime:null
      },
      getTaskReportDataArgs:null
    };
  },
  mounted(){

    //this.clear();
    //this.show();

   // this.drawOrganizationSpentTimeChart();
  },
  methods: {
    clear(){
        this.taskReportData = {
          spentTime:null
        };

        let monthlySpentTimeChart = this.$echarts.init(document.getElementById('monthlySpentTimeChart'));
        monthlySpentTimeChart.clear();
        let organizationSpentTimeChart = this.$echarts.init(document.getElementById('organizationSpentTimeChart'));
        organizationSpentTimeChart.clear();
    },
    show(){

        this.getTaskReportData();
        this.getMonthlySpentTime();
        this.getOrganizationSpentTime();

       // alert(this.taskReportDialogChildProps.taskId);
    },

    getTaskReportData(){
        this.getTaskReportDataArgs = {
                taskId: this.taskReportDialogChildProps.taskId,
                startYear: "",
                startMonth: "",
                endYear: "",
                endMonth: ""
            }

         this.$reportApi.getTaskReportData(this.getTaskReportDataArgs).then(res => {
          if (res.data.successful) {
            this.taskReportData = res.data.data;

          } else {
            this.$alert(res.data.message, "提示");
          }
         });
    },

    getMonthlySpentTime(){
        this.getMonthlySpentTimeDataTableGroupByTaskArgs = {
            PagingInfo: {
                currentPage: 1,
                totalPage: 0,
                pageSize: 1,
                totalCount: 0
            },
            OrderBy: "",
            Parameters: {
                taskId: this.taskReportDialogChildProps.taskId,
                startYear: "",
                startMonth: "",
                endYear: "",
                endMonth: ""
            }
        };

         this.$reportApi.getMonthlySpentTimeDataTableGroupByTask(this.getMonthlySpentTimeDataTableGroupByTaskArgs).then(res => {
          if (res.data.successful) {
            this.monthlySpentTimeData = res.data.data.data[0];
            this.drawMonthlySpentTimeChart();

          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },
    drawMonthlySpentTimeChart(){

        //准备X轴的月份和要显示的数据
        let monthArray = [];
        let monthSpentTimeArray = [];

         for(let key in this.monthlySpentTimeData)
            {
                if(key.indexOf('-') !='-1')
                {
                    monthArray.push(key.substring(1));
                    monthSpentTimeArray.push(
                        (this.monthlySpentTimeData[key]/this.workingHours).toFixed(1)
                        );
                }
            };

        // 基于准备好的dom，初始化echarts实例
        let monthlySpentTimeChart = this.$echarts.init(document.getElementById('monthlySpentTimeChart'))
        // 绘制图表
        monthlySpentTimeChart.setOption({
            title: { text: '月度工时统计' },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
             xAxis: {
                type: 'category',
                boundaryGap: false,
                data: monthArray
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: monthSpentTimeArray,
                type: 'line',
                areaStyle: {},
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
            }]
        });
    },

    getOrganizationSpentTime(){
        this.getOrganizationSpentTimeDataTableGroupByTaskArgs = {
            PagingInfo: {
                currentPage: 1,
                totalPage: 0,
                pageSize: 50,
                totalCount: 0
            },
            OrderBy: "",
            Parameters: {
                taskId: this.taskReportDialogChildProps.taskId,
                startYear: "",
                startMonth: "",
                endYear: "",
                endMonth: ""
            }
        };

         this.$reportApi.getOrganizationSpentTimeDataTableGroupByTask(this.getOrganizationSpentTimeDataTableGroupByTaskArgs).then(res => {
          if (res.data.successful) 
          {
            this.organizationSpentTimeData = res.data.data.data;
            this.drawOrganizationSpentTimeChart();

          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },

    drawOrganizationSpentTimeChart(){
        
         //准备X轴的月份和要显示的数据
        let organizationArray = [];
        let organizationSpentTimeArray = [];

        this.organizationSpentTimeData.forEach(item=>{
             organizationArray.push(item.organizationName);
                    organizationSpentTimeArray.push(
                        {
                            name:item.organizationName,
                            value:(item.spentTime/this.workingHours).toFixed(1)
                        }
                    );
        })

        // 基于准备好的dom，初始化echarts实例
        let organizationSpentTimeChart = this.$echarts.init(document.getElementById('organizationSpentTimeChart'))
        // 绘制图表
        organizationSpentTimeChart.setOption(
           {
                title: {
                    text: '各部门工时统计',
                  //  subtext: '纯属虚构',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: 10,
                    top: 20,
                    bottom: 20,
                    data: organizationArray,
                   // selected: data.selected
                },
                series: [
                    {
                        name: '部门',
                        type: 'pie',
                        radius: '55%',
                        center: ['40%', '50%'],
                        data: organizationSpentTimeArray,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            formatter: '{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                            backgroundColor: '#eee',
                            borderColor: '#aaa',
                            borderWidth: 1,
                            borderRadius: 4,
                            // shadowBlur:3,
                            // shadowOffsetX: 2,
                            // shadowOffsetY: 2,
                            // shadowColor: '#999',
                            // padding: [0, 7],
                            rich: {
                                hr: {
                                    borderColor: '#aaa',
                                    width: '100%',
                                    borderWidth: 0.5,
                                    height: 0
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 33
                                },
                                per: {
                                    color: '#eee',
                                    backgroundColor: '#334455',
                                    padding: [2, 4],
                                    borderRadius: 2
                                }
                            }
                        },
                    }
                ]
            }
        );}
    }
};
</script>

<style  rel="stylesheet/scss" lang="scss">


</style>


// WEBPACK FOOTER //
// src/views/report/taskReportDialog_Collect.vue